import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es'

const elementUi = Vue.use(ElementUI, {locale})

export default elementUi



// WEBPACK FOOTER //
// ./src/plugins/element-ui.js